"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSearch = void 0;
const downshift_1 = require("downshift");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const use_places_autocomplete_1 = __importStar(require("use-places-autocomplete"));
const react_google_maps_1 = require("@vis.gl/react-google-maps");
const locationSearchIcon_svg_1 = __importDefault(require("../../../assets/icons/locationSearchIcon.svg"));
const hooks_1 = require("../../../store/hooks");
const mapSlice_1 = require("../../../store/mapSlice");
const determineZoomLevel_1 = require("../../../utils/determineZoomLevel");
const geolocation_1 = require("../../../utils/geolocation");
const mapParamsHandler_1 = require("../../../utils/mapParamsHandler");
const S = __importStar(require("./LocationSearch.style"));
const OK_STATUS = "OK";
const LocationSearch = ({ isTimelapseView }) => {
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [items, setItems] = (0, react_1.useState)([]);
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(null);
    const [inputValue, setInputValue] = (0, react_1.useState)("");
    const { t } = (0, react_i18next_1.useTranslation)();
    const map = (0, react_google_maps_1.useMap)();
    const { setUrlParams } = (0, mapParamsHandler_1.useMapParams)();
    const { setValue, suggestions: { status, data }, clearSuggestions, } = (0, use_places_autocomplete_1.default)();
    const { isOpen, getMenuProps, getInputProps, highlightedIndex, getItemProps, } = (0, downshift_1.useCombobox)({
        onInputValueChange: ({ inputValue }) => {
            setValue(inputValue);
            setInputValue(inputValue);
        },
        items: data,
        itemToString(item) {
            return item ? item.description : "";
        },
        selectedItem,
        onSelectedItemChange: ({ selectedItem: newSelectedItem }) => {
            setSelectedItem(newSelectedItem);
            handleSelect(newSelectedItem);
        },
        inputValue,
    });
    const displaySearchResults = isOpen && items.length > 0;
    const handleSelect = (item) => __awaiter(void 0, void 0, void 0, function* () {
        if (!item)
            return;
        setValue(item.description, false);
        clearSuggestions();
        const results = yield (0, use_places_autocomplete_1.getGeocode)({ address: item.description });
        const { lat, lng } = yield (0, use_places_autocomplete_1.getLatLng)(results[0]);
        const { zoom, bounds } = (0, determineZoomLevel_1.determineZoomLevel)(results);
        setUrlParams([
            {
                key: mapParamsHandler_1.UrlParamsTypes.currentCenter,
                value: JSON.stringify({ lat, lng }),
            },
            {
                key: mapParamsHandler_1.UrlParamsTypes.currentZoom,
                value: zoom.toString(),
            },
        ]);
        if (bounds && map) {
            map.fitBounds(bounds);
        }
        else {
            map === null || map === void 0 ? void 0 : map.setZoom(zoom);
            map === null || map === void 0 ? void 0 : map.panTo({ lat, lng });
        }
        setTimeout(() => {
            dispatch((0, mapSlice_1.setFetchingData)(true));
        }, 200);
    });
    const handleBrowserLocation = () => __awaiter(void 0, void 0, void 0, function* () {
        const location = yield (0, geolocation_1.getBrowserLocation)(map, setUrlParams);
        if (location) {
            setInputValue("");
            setItems([]);
            setTimeout(() => {
                dispatch((0, mapSlice_1.setFetchingData)(true));
            }, 200);
        }
        else {
            console.log(t("map.locationError"));
        }
    });
    (0, react_1.useEffect)(() => {
        if (status === OK_STATUS && data.length) {
            setItems(data);
        }
    }, [data, status]);
    return (react_1.default.createElement(S.SearchContainer, { "$isTimelapseView": isTimelapseView },
        react_1.default.createElement(S.SearchInput, Object.assign({ placeholder: t("map.searchPlaceholder"), "$displaySearchResults": displaySearchResults }, getInputProps())),
        react_1.default.createElement(S.LocationSearchButton, { "aria-label": t("map.browserLocationButton"), type: "button", onClick: handleBrowserLocation },
            react_1.default.createElement(S.LocationSearchIcon, { src: locationSearchIcon_svg_1.default, alt: t("map.searchIcon") })),
        react_1.default.createElement(S.SuggestionsList, Object.assign({ "$displaySearchResults": displaySearchResults }, getMenuProps()),
            react_1.default.createElement(S.Hr, { "$displaySearchResults": displaySearchResults }),
            isOpen &&
                items.map((item, index) => (react_1.default.createElement(S.Suggestion, Object.assign({ key: item.place_id, "$isHighlighted": highlightedIndex === index }, getItemProps({ item, index })), item.description))))));
};
exports.LocationSearch = LocationSearch;
